import directives from './module';
import {Utils} from 'underscore-extensions';

interface DocumentNoScrollOnChangesObject extends ng.IOnChangesObject {
    documentNoScroll: ng.IChangesObject<string>;
}

class DocumentNoScroll {
    static isDisabled = false;
           documentEl = document.documentElement;
           className  = 'noscroll';

    private disableScroll() {
        if (DocumentNoScroll.isDisabled) {
            return;
        }
        DocumentNoScroll.isDisabled = true;

        const scrollTop = window.scrollY || window.pageYOffset;
        this.documentEl.classList.add(this.className);
        document.body.style.top = `-${scrollTop}px`;
    };

    private enableScroll() {
        if (!DocumentNoScroll.isDisabled) {
            return;
        }
        DocumentNoScroll.isDisabled = false;

        const scrollTop         = document.body.style.top ? parseInt(document.body.style.top, 10) : 0;
        document.body.style.top = '';
        this.documentEl.classList.remove(this.className);
        window.scrollTo(0, Math.abs(scrollTop));
    };

    $onChanges(onChangesObj: DocumentNoScrollOnChangesObject) {
        const {currentValue, previousValue} = onChangesObj.documentNoScroll;

        Utils.rAF(() => {
            if (currentValue) {
                this.disableScroll();
            } else if (!currentValue && previousValue) {
                this.enableScroll();
            }
        });
    }

    $onDestroy() {
        this.enableScroll();
    }
}

directives.directive('documentNoScroll', () => ({
    controller: DocumentNoScroll,
    bindToController: {
        documentNoScroll: '<'
    }
}));



// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/documentNoScroll.ts